function toStringDate(date: Date): string {
	const day = String(date.getDate()).padStart(2, '0');
	const month = String(date.getMonth() + 1).padStart(2, '0');
	const year = date.getFullYear();

	return `${day}.${month}.${year}`;
}

function toStringDateAndTime(date: Date): string {
	const datePart = toStringDate(date);
	const hours = String(date.getHours()).padStart(2, '0');
	const minutes = String(date.getMinutes()).padStart(2, '0');

	return `${datePart} ${hours}:${minutes}`;
}

export { toStringDate, toStringDateAndTime };
